import common from './common.json'

const messages = {
  ...common
}

export default messages
